import React from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router';

import classNames from 'classnames';

import { getCareTypesOptions } from 'apis/IncentiveAPI';
import SelectAdvancedFilter from 'components/lib/SelectAdvancedFilter';
import { useAppSelector } from 'store/hook';

import { useIncentivesDataContext } from '../IncentivesDataContext';

type CareTypeType = {
  id: number;
  name: string;
};

const IncentivesFiltersCareType = () => {
  const { currentUser } = useAppSelector((state) => state.auth);
  const { selectedCompany } = useAppSelector((state) => state.global);
  const { filters, setFilters } = useIncentivesDataContext();

  const handleSelect = (selection: any[]) => {
    const values = selection.map((item: any) => item.value);
    setFilters({ ...filters, page: 1, careTypes: values });
  };

  const { data } = useQuery({
    queryKey: ['careTypes', 'incentives', selectedCompany],
    queryFn: () => getCareTypesOptions(),
    enabled: Boolean(selectedCompany) || Boolean(currentUser?.holding),
    refetchOnWindowFocus: false,
  });

  const options = data?.map((item: CareTypeType) => ({
    label: item.name,
    value: item.id,
  }));

  return (
    <SelectAdvancedFilter
      className={classNames({ active: Boolean(filters.careTypes?.length) })}
      placeholder={'Care Type'}
      options={options}
      defaultValue={filters?.careTypes ?? []}
      onSelect={handleSelect}
    />
  );
};

export default IncentivesFiltersCareType;
